/**
 * 이미지
 */
import { useCallback, MouseEvent, Fragment } from 'react';
import type { IModal } from '../common/Modal';
import type { IImage, l10nType } from '@type/index';

const setImageItem = (item: IImage): IImage | null => {
  if (!item || typeof item !== 'object') {
    return null;
  }

  const imageUrl = item?.imageUrl?.split('|')[0];
  const thumbnail = item?.thumbnail?.split('|')[0];
  return item && typeof item === 'object'
    ? {
        ...item,
        imageUrl,
        thumbnail: imageUrl || thumbnail,
      }
    : null;
};

const ImageArticle = ({
  item,
  l10n,
  imageClickCallback,
}: {
  item: IImage;
  l10n: l10nType;
  imageClickCallback: (modalData: IModal['data']) => void;
}) => {
  const data = setImageItem(item);

  if (!data) {
    return <Fragment />;
  }

  const { url, imageUrl, thumbnail, width, height, srcWidth, srcHeight, title } = data;

  const clickCallback = useCallback(
    (e: MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault();

      typeof imageClickCallback === 'function' &&
        imageClickCallback({
          url: imageUrl,
          width: !srcWidth ? width : srcWidth,
          height: !srcHeight ? height : srcHeight,
          title,
        });
    },
    [item]
  );

  return (
    <div className="search-item-content">
      <a href={url} onClick={clickCallback}>
        <div className="search-item-thumbnail">{thumbnail ? <img src={thumbnail} alt="" /> : <Fragment />}</div>
        <div className="search-item-title-wrap">
          <div className="search-item-title">{title}</div>
        </div>
      </a>
    </div>
  );
};

export default ImageArticle;
